import React, { Component } from 'react'
import { Select, MagicInput } from 'hljd'
import style from './style.module.less'

const { Option } = Select

/**
 * 使用场景
 */
export default class extends Component {
  render() {
    const { use_case, title, changeField } = this.props
    return (
      <div>
        <Select
          size="large"
          value={use_case}
          onChange={changeField('use_case')}
          style={{ width: 140 }}
          className={style.select}
        >
          <Option value={1}>菜单费优惠</Option>
          <Option value={2}>场地费优惠</Option>
          <Option value={3}>订单费优惠</Option>
          <Option value={4}>试菜费优惠</Option>
          <Option value={0}>其他优惠</Option>
        </Select>
        {use_case === 0 && (
          <MagicInput
            style={{ width: 440, marginLeft: 10 }}
            value={title}
            onChange={changeField('title')}
            placeholder="请输入使用说明（展示给用户看）"
            maxLength={20}
            showCount
            countPosition="right"
          />
        )}
      </div>
    )
  }
}
